export class Site {
    nome: string;
    situacao: string;
    corPrincipal: string;
}
